import { useTranslation } from 'react-i18next';
import { useGame } from '../../store/gameStore';
import { startTutorial } from '../../tutorial/startTutorial';
import { Button } from '../common/Button';

const KEYS = [
  'travel',
  'confirm',
  'back',
  'mode',
  'log',
  'standings',
  'help',
  'info',
  'save',
  'end',
] as const;

export function HelpContent() {
  const { t } = useTranslation();
  return (
    <>
      <p>{t('help.intro')}</p>
      <h2 className="mt-4 text-xl font-semibold">{t('help.keys')}</h2>
      <table className="mt-2 w-full text-left text-sm">
        <tbody>
          {KEYS.map((k) => (
            <tr key={k} className="border-t border-line">
              <th scope="row" className="py-1 pr-3 font-mono">
                {t(`help.key.${k}`)}
              </th>
              <td className="py-1">{t(`help.key.${k}.desc`)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}

export function HelpScreen() {
  const { t } = useTranslation();
  const go = useGame((s) => s.go);
  const hasGame = useGame((s) => s.state !== null);
  return (
    <section className="mx-auto max-w-xl p-4 sm:p-6">
      <h1 className="mb-4 text-3xl font-bold">{t('help.heading')}</h1>
      <HelpContent />
      <div className="mt-6 flex flex-wrap gap-2">
        {/* UX 7.6: the tutorial is replayable from How to Play, not only on a first game. */}
        <Button variant="primary" onClick={startTutorial} data-testid="tutorial-start">
          {t('tutorial.start')}
        </Button>
        <Button onClick={() => go(hasGame ? 'game' : 'title')} data-testid="back">
          {t('help.close')}
        </Button>
      </div>
    </section>
  );
}
